import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { DynamicWidgetDirective } from '@app/directives/dynamic-widget.directive';
import { CardHeaderInput } from '@trackback/widgets';
import { AsyncPipe } from '@angular/common';
import { ParsePipe } from '@app/pipes/parse.pipe';
import { MatCardHeader } from '@angular/material/card';
import { WidgetInputBaseComponent } from '@app/widgets/widget-input-base.component';

@Component({
  selector: 'tb-card-header',
  imports: [DynamicWidgetDirective, AsyncPipe, ParsePipe, MatCardHeader],
  template: `
    <mat-card-header [class]="input().styleClasses | parse: context() | async">
      @if (input().avatar; as avatar) {
        <ng-container mat-card-avatar>
          <ng-container [dynamicWidget]="avatar" [context]="context()" />
        </ng-container>
      }
      <ng-container ngProjectAs="mat-card-title">
        @if (input().title; as title) {
          <ng-container [dynamicWidget]="title" [context]="context()" />
        }
      </ng-container>
      <ng-container ngProjectAs="mat-card-subtitle">
        @if (input().subtitle; as subtitle) {
          <ng-container [dynamicWidget]="subtitle" [context]="context()" />
        }
      </ng-container>
      @for (child of input().children; track $index) {
        <ng-container [dynamicWidget]="child" [context]="context()" />
      }
    </mat-card-header>
  `,
  styles: `
    tb-card-header {
      display: contents;
      mat-card-header > .mat-mdc-card-header-text {
        flex: 1;
      }
    }
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class CardHeaderComponent extends WidgetInputBaseComponent<CardHeaderInput> {}
